import { Button } from 'primereact/button';
import styles from "./Wrapper.module.scss";

function Section({ label, actions, children }) {
  return (
    <div className={styles.sectionWrapper}>
      <div className={styles.topContainer}>
        <h3 className={styles.sectionTitle}>{label}</h3>
        <div className={styles.sectionActions}>
          {actions &&
            actions.map((action, index) => (
              <Button
                key={index}
                size="small"
                outlined
                rounded
                label={action.label}
                iconPos="left"
                icon={`pi ${action.icon}`}
                onClick={action.onClick}
                className={styles.actionButton}
              />
            ))}
        </div>
      </div>
      {children}
    </div>
  );
}

export default Section;
